import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
  Stack,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PeopleIcon from "@mui/icons-material/People";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";



import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchChallengeData,
  fetchjoinChallengeData,
} from "../apiservices/ApiService";
import AppNavigation from "../navigation/AppNavigation";

const Fsn136ChallengeLanding = ({ onTap }) => {

  const { handleNavigation } = AppNavigation();
  const navigate = useNavigate(); // Initialize navigation
  const challengeId = onTap.FAI.challengeId;
  const [challengeData, setChallengeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await fetchChallengeData({ challengeId: challengeId });
        setChallengeData(data);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  // Function to handle the back button
  const handleBackButtonPress = () => {

    if (window.Android) {
      // Call Android's Java function via the bridge
      window.Android.onBackPressed();
    } else {
      navigate(-1); // Navigate back
    }
  };


  const handleJoinChallenge = async () => {

    try {
      const response = await fetchjoinChallengeData({ challengeId: challengeId });
      console.log("Join Challenge Response:", response.buttonProperty);
      // alert("You have successfully joined the challenge!");
      // handleBackButtonPress();
      // handleCardClick(response.buttonProperty);

      handleNavigation(response.buttonProperty); // Pass onTap to the navigation handler
    } catch (err) {
      console.error("Error joining challenge:", err);
      // alert(err.message || "Failed to join the challenge.");
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: "#2c2c2c",
          color: "#ffffff",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          backgroundColor: "#2c2c2c",
          color: "#ffffff",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: challengeData.challengeBackgroundColor,
        color: "#ffffff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: 2,
      }}
    >
      {/* Header */}
      <Box>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton sx={{ color: "#ffffff" }}>
              <ArrowBackIosIcon onClick={handleBackButtonPress} />
            </IconButton>
            <Box>
              <Typography variant="h7">
                {challengeData?.challengeTitle || "Challenge Title"}
              </Typography>
              <Typography variant="subtitle2" sx={{ color: "#aaaaaa" }}>
                {challengeData?.challengeSubText || "Complete task daily"}
              </Typography>
            </Box>
          </Stack>
          <IconButton sx={{ color: "#ffffff" }}>
            <InfoOutlinedIcon />
          </IconButton>
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Stack direction="row" spacing={3} alignItems="center">
            <Stack direction="row" spacing={1} alignItems="center">
              <CalendarTodayIcon fontSize="small" />
              <Typography variant="body2">
                {challengeData?.challengeDuration || "1st Jan - 31st Jan"}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <PeopleIcon fontSize="small" />
              <Typography variant="body2">
                {challengeData?.challengeJoinedCount || "938 Participants"}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Box>

      {/* Challenge Details */}
      <Box>
        <Box
          sx={{
            border: "1px solid #ffffff",
            borderRadius: 2,
            padding: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            {challengeData?.challengeQuote ||
              "Be consistent and get UHT Rewards"}
          </Typography>
        </Box>
      </Box>

      {/* Footer */}
      <Box>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "#ffffff",
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            <img
              src={challengeData?.sponsorLogo}
              alt="Profile"
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
          <Typography variant="body2">
            {challengeData?.prizeText || "Top 10 winners get 1000 UHT Rewards"}
          </Typography>
        </Stack>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#ffffff",
            color: "#2c2c2c",
            fontWeight: "bold",
            borderRadius: 2,
            mt: 2,
            textTransform: "none",
          }}
          fullWidth
          onClick={handleJoinChallenge} // Attach the click handler
        >
          {challengeData?.buttonProperty.Text || "Join Challenge"}
        </Button>
      </Box>
    </Box>
  );
};

export default Fsn136ChallengeLanding;
